// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inviteList_root__1t3n9 {\n  display: flex;\n  width: 100%;\n  background: #fafafa;\n  justify-content: center; }\n", ""]);
// Exports
exports.locals = {
	"root": "inviteList_root__1t3n9"
};
module.exports = exports;
